export enum CreditNoteStatusEnum {
  VALIDATED = 'VALIDATED',
  TRANSMITTED = 'TRANSMITTED',
  REFUSED = 'REFUSED'
}
